import { Component, HostListener, Input } from '@angular/core';
import { PlayForFunAlertLayoutComponent } from '../core/playforfunalert.layout.component';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { UtilService } from 'src/app/util/UtilService';

@Component({
    selector: 'app-playforfunalertlayoutdesktop',
    templateUrl: './playforfunalert.layout.desktop.component.html',
    styleUrls: ['../css/playforfunalert.layout.desktop.component.scss'],
    standalone: false
})
export class PlayForFunAlertLayoutDesktopComponent extends PlayForFunAlertLayoutComponent {
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }
  constructor(public _utilService: UtilService) {
    super(_utilService);
  }
  ngOnInit() {
    super.ngOnInit();
    //this.userCurrency = this.data.userCurrency;
  }
}
